import React from 'react';
import { connect } from 'react-redux';
import LargeTitleCard from './cards/large/LargeTitleCard.jsx';
import LargeImageCard from './cards/large/LargeImageCard.jsx';
import LargeTextCard from './cards/large/LargeTextCard.jsx';
import LargeLargeTextCard from './cards/large/LargeLargeTextCard.jsx';
import LargeVideoCard from './cards/large/LargeVideoCard.jsx';
import LargeAdCard from './cards/large/LargeAdCard.jsx';
import LargeQuoteCard from './cards/large/LargeQuoteCard.jsx';
import LargeAnnouncementCard from './cards/large/LargeAnnouncementCard.jsx';
import LargeCreditsCard from './cards/large/LargeCreditsCard.jsx';
import actions from './../actions/large-card-actions';
import smallActions from './../actions/small-card-actions';


class LargeCardFramework extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'LargeCardFramework';

    // called when an animationFrame is rendering
    this.ticking = false;

    // bind functions to component
    this.renderCards = this.renderCards.bind(this);
    this.renderCard = this.renderCard.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    this.onScroll();
  }


  /**
   * Scroll handler
   * @returns {undefined} undefined
   */
  onScroll() {
    if (typeof document !== 'undefined') {
      const doc = document.documentElement;
      const scrollTop = (window.pageYOffset || doc.scrollTop) -
        (doc.clientTop || 0);

      if (!this.ticking) {
        this.ticking = true;

        window.requestAnimationFrame(() => {
          this.props.dispatch(actions.setScrollTop(scrollTop));

          this.ticking = false;
        });
      }
    }
  }


  /**
   * Renders cards
   * @returns {Array<ReactElement>} An array of Card components
   */
  renderCards() {
    const data = this.props.data;
    const cards = [];

    for (let i = 0; i < data.length; i++) {
      cards.push(this.renderCard(data[i], i));
    }

    return cards;
  }


  /**
   * Renders card
   * @param {Object} data - A data object
   * @param {Number} iteration - The iteration of the card
   * @returns {ReactElement} A Card component
   */
  renderCard(data, iteration) {
    let element;
    const key = 'card-' + data.order;

    if (data.type === 'title') {
      element = (
        <LargeTitleCard
          data={data}
          iteration={iteration}
          key={key}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    }

    if (data.type === 'image') {
      element = (
        <LargeImageCard
          data={data}
          iteration={iteration}
          key={key}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    }

    if (data.type === 'text') {
      element = (
        <LargeTextCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    if (data.type === 'large-text') {
      element = (
        <LargeLargeTextCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    if (data.type === 'inline-video' || data.type === 'video') {
      element = (
        <LargeVideoCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    if (data.type === 'ad') {
      element = (
        <LargeAdCard
          data={data}
          iteration={iteration}
          largeBreakpoint={this.props.largeBreakpoint}
          key={key}
        />
      );
    }

    if (data.type === 'quote') {
      element = (
        <LargeQuoteCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    if (data.type === 'announcement') {
      element = (
        <LargeAnnouncementCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    if (data.type === 'credits') {
      element = (
        <LargeCreditsCard
          data={data}
          iteration={iteration}
          key={key}
        />
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const cards = this.renderCards();
    const className = 'component-large-card-framework';

    return (
      <div className={className}>
        <div className='cards-wrapper'>
          <div className='cards grid'>
            {cards}
          </div>
        </div>
      </div>
    );
  }
}

/**
 * Expected propTypes
 * @prop {Array<Object>} data - An array of json objects
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Number} largeBreakpoint - A width breakpoint
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 */
LargeCardFramework.propTypes = {
  data: React.PropTypes.array.isRequired,
  dispatch: React.PropTypes.func,
  largeBreakpoint: React.PropTypes.number,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
};


export default connect(({ mediaLabCardFrameworkState, largeCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, largeCardFrameworkState }))(LargeCardFramework);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/LargeCardFramework.jsx
 **/